import { render } from "./documentsList.vue?vue&type=template&id=16eb78b3&scoped=true&ts=true"
import script from "./documentsList.vue?vue&type=script&lang=ts"
export * from "./documentsList.vue?vue&type=script&lang=ts"

import "./documentsList.vue?vue&type=style&index=0&id=16eb78b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16eb78b3"]])

export default __exports__